// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Навички ШІ» (AI Skills, ключ `ais`, група `ai-management`). */
export const aiSkillsManifest: IModuleManifest = {
  key: 'ais',
  group: 'ai-management',
  slug: 'ai-skills',
  prefix: 'AIS',
  name: { en: 'AI Skills', uk: 'Навички ШІ' },
  entities: [
    { key: 'ais', slug: 'ais', name: { en: 'AI Skills', uk: 'Навички ШІ' }, main: true },
    { key: 'skill_version', slug: 'skill-version', name: { en: 'Skill Versions', uk: 'Версії' }, main: false },
    { key: 'skill_run', slug: 'skill-run', name: { en: 'Skill Runs', uk: 'Запуски' }, main: false },
    { key: 'skill_rule', slug: 'skill-rule', name: { en: 'Skill Rules', uk: 'Правила' }, main: false },
  ],
  loadState: () => import('./state/aiSkillsSlice').then((m) => m.aiSkillsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
